import React, { useEffect, useState } from 'react'
import { Table, Select, Button, message, Flex, Space, Typography, Popconfirm, Image, Spin, Modal, List, Card } from "antd";
import { CloseOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { decryptCredentials, downloadFileHandle } from '../../utils/commonFunc';
import axios from 'axios';
import UserEdit from './UserEdit';
import dayjs from 'dayjs';

function UserRequest({ isLoading }) {
    const [userList, setUserList] = useState();
    const [isEditModal, setIsEditModal] = useState(false)
    const [editData, seteditData] = useState(null);
    const [loading, setLoading] = useState(false)
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
    const [currentSubscriptions, setCurrentSubscriptions] = useState([]);

    const columns = [
        {
            title: "#",
            dataIndex: "count",
            key: "count",
            width: "30px"
        },
        {
            title: "Name",
            dataIndex: "fullname",
            key: "name",
            width: "250px",
            fixed: "left",
        },
        {
            title: "Phone Number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: "140px",
            fixed: "left",
        },
        {
            title: "Referral Code",
            dataIndex: "referralCode",
            key: "referralCode",
            width: "140px",
            fixed: "left",
        },
        {
            title: "Reffered By",
            dataIndex: "refferedBy",
            key: "refferedBy",
            width: "140px",
            fixed: "left",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            width: "250px",
            fixed: "left",
        },
        {
            title: "Password",
            dataIndex: "password",
            width: "150px",
            key: "password",
        },
        {
            title: "User Code",
            dataIndex: "userCode",
            key: "userCode",
            width: "120px",
        },
        {
            title: "Date of Birth",
            dataIndex: "dob",
            key: "dob",
            width: '130px',
        },
        // {
        //     title: "Plan ID",
        //     dataIndex: "planId",
        //     key: "planId",
        //     width: '180px',
        // },
        {
            title: "Payment Method",
            dataIndex: "paymentMethod",
            key: "paymentMethod",
            width: '180px',
            render: (method) => method ? method.replace(/_/g, ' ') : '-',
        },
        {
            title: "Subscriptions",
            dataIndex: "subscriptions",
            key: "subscriptions",
            width: "80px",
            fixed: "left",
            render: (_, rec) => (
                <Button
                    icon={<EyeOutlined />}
                    onClick={() => {
                        setCurrentSubscriptions(rec.subscriptions || []);
                        setIsSubscriptionModalOpen(true);
                    }}
                />
            )
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            width: '180px',
            render: (text) =>text ? `$${text}` : '-'
        },
        {
            title: "Plan Quantity",
            dataIndex: "planQuantity",
            key: "planQuantity",
            width: "150px",
            render: (quantity) => {
                console.log('Plan Quantity:', quantity);
                return quantity !== undefined ? quantity : '-';
            },
        },
        {
            title: "Discount",
            dataIndex: "discount",
            key: "discount",
            width: '180px',
            render: (text) =>text ? `$${text}` : '-'
        },
        {
            title: "Paid Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            width: '180px',
            render: (text) =>text ? `$${text}` : '-'
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            width: '180px',
            render: (e, rec) => <Select
                style={{ width: '100px' }}
                defaultValue={e}
                value={e}
                // disabled={!rec.action.account_number}
                onChange={(val) => statusChange(val, rec)}
                options={[
                    { value: 'APPROVED', label: 'Approve' },
                    { value: 'REJECTED', label: 'Reject' }
                ]}
            />
        }, {
            title: "Action",
            key: "action",
            dataIndex: "action",
            width: '50px',
            render: (e, rec) => {
                return (
                    <Space>
                        <Button type="default" icon={<EditOutlined />} size={"middle"} onClick={() => {
                            setIsEditModal(true)
                            seteditData(rec)
                        }} />
                        <Popconfirm
                            description="Are you sure you want to delete this account?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => deleteUser(rec.key)}
                        >
                            <Button icon={<CloseOutlined />} danger size={"middle"} />
                        </Popconfirm>
                    </Space>
                )
            }

        }
    ];

    useEffect(() => {
        fetchList({})
    }, []);

    const deleteUser = (id) => {
        setLoading(true)
        axios.delete(`${process.env.REACT_APP_ADMIN_API_URL}admin/delete-user/${id}`, {
            headers: {
                'x-product-type': 'PIP_GRID'
            }
        })
            .then((res) => {
                fetchList({})
                setLoading(false)
                message.success(res.message || "User Deleted")
            })
            .catch(e => {
                message.error(e.message)
            })
    }

    const statusChange = (val, rec) => {
        setLoading(true)
        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}admin/update-request-status`, {
            userId: rec?.key, status: val
        }, {
            headers: {
                'x-product-type': 'PIP_GRID'
            }
        }).then(res => {
            message.success(res.message || "Status updated successfully!")
            fetchList({})
            setLoading(false)
        })
            .catch(e => message.error(e.message))
    }

    const fetchList = () => {
        setLoading(true)
        axios.get(`${process.env.REACT_APP_ADMIN_API_URL}admin/subscription-requests/pending`, {
            headers: {
                'x-product-type': 'PIP_GRID'
            }
        })
            .then(res => {
                const data = res?.data?.data?.map((dt, i) => {
                    if (!dt.hashedPassword || !dt.salt) {
                        console.warn(`⚠️ Missing hashedPassword or salt for User ${i + 1}:`, dt);
                    }
                    const decryptedPassword = decryptCredentials(dt?.salt, dt?.hashedPassword);

                    if (!dt?._id) return
                    
                    // console.log("🚀 ~ fetchList ~ dt:", dt?.referralInfo?.refferedBy?.email)
                    return {
                        count: `${i + 1}`,
                        key: dt?._id,
                        fullname: `${dt?.fullName || ''}`,
                        phoneNumber: dt?.phoneNumber || '-',
                        dob: dt?.dob ? dayjs(dt.dob).format("DD-MM-YYYY") : "-",
                        referralCode: dt?.referralInfo?.refferalCode || '-',
                        refferedBy: dt?.referralInfo?.refferedBy?.email || '-',
                        email: dt?.email || '-',
                        status: dt?.loginRequestStatus && "Pending",
                        city: dt?.city || '',
                        state: dt?.state || '',
                        country: dt?.country || '',
                        productName: dt?.productName || '',
                        brokerName: dt?.brokerName,
                        investorPassword: dt?.investorPassword || "-",
                        brokerServer: dt?.brokerServer || "-",
                        balance: dt?.balance,
                        password: decryptedPassword || "-",
                        accountNumber: dt?.accountNumber,
                        accountName: dt?.accountName,
                        transactionNumber: dt?.transactionNumber || '-',
                        transactionFiles: dt?.transactionFiles,
                        userCode: dt?.userCode,
                        planId: dt?.subscriptions?.[0]?.planId,
                        paymentMethod: dt?.subscriptions?.[0]?.paymentMethod,
                        totalAmount: dt?.subscriptions?.[0]?.planPrice,
                        planQuantity: dt?.subscriptions?.[0]?.planQuantity,
                        discount: dt?.subscriptions?.[0]?.discountAmount,
                        paidAmount: dt?.subscriptions?.[0]?.paidAmount,
                        subscriptions: dt?.subscriptions,
                    };
                });
                setUserList(data)
                setLoading(false)
            }).catch(e => {
                console.log(e);
            })
    }

    const aggregatedSubscriptions = Object.values(currentSubscriptions.reduce((acc, item) => {
        const planId = item?.planId?.[0]?._id || item?.planId?.[0]?.name;
        if (!acc[planId]) {
            acc[planId] = { ...item, totalQuantity: 0 };
        }
        acc[planId].totalQuantity += (item.planQuantity || 0);
        return acc;
    }, {}));

    return (
        <Spin spinning={loading} size="large">
            <Typography.Title level={3} className="page-title">Request</Typography.Title>
            <Flex justify="end" gap={5} style={{ marginBottom: "20px" }}>
                <Button type="primary" onClick={() => downloadFileHandle(userList, 'pending_users')}>
                    Download
                </Button>
            </Flex>

            <Table loading={isLoading} columns={columns} dataSource={userList} scroll={{ x: 'max-content' }} />

            <Modal
                title={<div style={{ marginBottom: "15px" }}>Subscription Details</div>}
                open={isSubscriptionModalOpen}
                onCancel={() => setIsSubscriptionModalOpen(false)}
                footer={null}
                centered
                width={500}
            >
                <List
                    grid={{ gutter: 16, column: 2 }}
                    dataSource={aggregatedSubscriptions}
                    renderItem={(item) => (
                        <List.Item>
                            <Card title={item?.planId?.[0]?.name || "Unknown Plan"} bordered={true}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                    <div><strong>Price:</strong> {item?.planId?.[0]?.price} {item?.planId?.[0]?.currency}</div>
                                    <div><strong>Quantity:</strong> {item?.totalQuantity}</div>
                                    <div><strong>Status:</strong> {item?.status}</div>
                                </div>
                            </Card>
                        </List.Item>
                    )}
                />
            </Modal>
            {isEditModal && (
                <UserEdit
                    editData={editData}
                    isLoading={false}
                    onClose={() => setIsEditModal(false)}
                    fetchList={fetchList}
                    type="request"
                />
            )}
        </Spin>
    );
}
const mapStateToProps = ({ login, loading }) => {
    const { user } = login
    const { isLoading } = loading
    return { user, isLoading }
}
export default connect(mapStateToProps, {})(UserRequest)